import ApplicationModel, { attr } from '../ApplicationModel';
import { type BookmarksNowNextLaterPaneAttributes } from './generated/BookmarksNowNextLaterPaneAttributes';
import { model } from '../modelBuilder';

interface BookmarksNowNextLaterPane
  extends BookmarksNowNextLaterPaneAttributes {}

@model
class BookmarksNowNextLaterPane extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksNowNextLaterPane' = 'BookmarksNowNextLaterPane';
  get typename(): 'BookmarksNowNextLaterPane' {
    return 'BookmarksNowNextLaterPane';
  }

  static bookmarkName = 'Bookmarks::NowNextLaterPane';

  static inputType = 'NowNextLaterPaneAttributes';

  static fields = {
    daysFromToday: attr({ writable: true, readable: true }),
    description: attr({ writable: true, readable: true }),
    endDate: attr({ writable: true, readable: true }),
    sortBy: attr({ writable: true, readable: true }),
    startDate: attr({ writable: true, readable: true }),
    timeframe: attr({ writable: true, readable: true }),
    title: attr({ writable: true, readable: true }),
  };
  // End auto-generated
}

export default BookmarksNowNextLaterPane;
